// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "545") return "js/vendors-f839ca2925b506ac.js";
if (chunkId === "691") return "js/vendor-super-form-ddb6643e931aaef4.js";
  // return url for filenames based on template
  return "js/" + {"94": "vendor-vega","960": "vendor-interrai-english",}[chunkId] + "-" + {"94": "200bff5849b2c427","960": "b88226ff0b1224db",}[chunkId] + ".chunk.js"
}